module.exports = __webpack_public_path__ + "resources/icon_44_favor_active.447879febf560094.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_favor_active.png
// module id = 455
// module chunks = 0 1 2 3 4